﻿import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectProductAndResultType } from '../redux/selectors';
import ProductType from '../enums/productType';
import ResultType from '../enums/resultType';
import { searchParametersSlice } from '../redux/slices';
import getDefaultResultType from '../services/resultTypeService';
import getDefaultProductType from '../services/productTypeService';

export default class CustomHousingType {
  constructor() {
    this.selector = '[data-housing-type="custom"]';
    store$.pipe(map(selectProductAndResultType), distinctUntilChanged())
      .subscribe(this.onProductAndResultTypeChange.bind(this));
  }

  /**
   * The dispatchAction function dispatches a fetchCustom action with the payload obtained from the
   * getSearchCommands function.
   */
  dispatchFetchResultAction() {
    const payload = this.getSearchCommands();
    store.dispatch(searchParametersSlice.actions.fetchCustom(payload));
  }

  /**
   * Gets the node element of luxury box.
   * @returns {Node} element.
   */
  getNode() {
    return document.querySelector(this.selector);
  }

  /**
   * getSearchCommands: Gets the search command property of this Housing Box.
   * @returns The search command property string.
   */
  getSearchCommands() {
    const searchCommandPropertyStructure = {
      productType: this.productTypeToApply,
      resultType: this.resultTypeToApply,
    };

    return searchCommandPropertyStructure;
  }

  /**
   * The function `onProductAndResultTypeChange` checks the `resultType` and `productType` to be able to update
   * the result and product type that the box should apply.
   * @param productAndResultType - It represents the object with the product and result type.
   */
  onProductAndResultTypeChange(productAndResultType) {
    const { productType, resultType } = productAndResultType;
    this.toggleBox(productType);

    // We have to open the home result type when this button is clicked. In other words, this is when the button
    // is not actived and it was clicked, so we should open the Custom Homes search.
    if (productType !== ProductType.Custom.toString() && productType !== ProductType.BuildOnYourLot.toString()) {
      this.resultTypeToApply = ResultType.Homes.toString();
      this.productTypeToApply = ProductType.Custom.toString();
      return;
    }

    // Otherwise, it means the custom/build on your lot search are actived, so if the button is clicked, we should
    // use the default result type when button is clicked again to deactivate the custom/build on your lot search.
    this.resultTypeToApply = getDefaultResultType(resultType);
    this.productTypeToApply = getDefaultProductType(productType, resultType);
  }

  toggleBox(productType) {
    const node = this.getNode();
    if (productType === ProductType.BuildOnYourLot.toString() || productType === ProductType.Custom.toString()) {
      node.selected = true;
    } else {
      node.selected = false;
    }
  }
}
